const DriversSlice = ({ block }) => {
  if (!block || !block.items) return null;
  return (
    <>
      <div className="drivers-container">
        {block.items.map((item, index) => (
          <div className="driver-card" key={index}>
            <h3 className="software-name">{item.software_name}</h3>
            <p className="revision-number">Version: {item.revision_number}</p>
            <p className="release-date">Release Date: {item.release_date}</p>
            <p className="file-size">File Size: {item.file_size}</p>
            <a
              className="download-link"
              target="blank"
              href={item.downloadable_link}
            >
              Download
            </a>
          </div>
        ))}
      </div>

      <style jsx>{`
        .drivers-container {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 20px;
          padding: 20px 20px 50px;
          margin: auto;
          max-width: 1440px;
        }

        .driver-card {
          display: flex;
          flex-direction: column;
          align-items: center;
          background-color: #141414;
          padding: 20px;
          border-radius: 10px;
          width: 100%;
          max-width: 330px;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
          transition: transform 0.2s ease;
        }

        .driver-card:hover {
          transform: translateY(-5px);
        }

        .software-name {
          color: #e4e4e4;
          font-size: 28px;
          margin-top: 15px;
          font-weight: 400;
          margin-bottom: 10px;
          font-family: 'big_noodle_titling';
        }

        .revision-number,
        .release-date,
        .file-size {
          font-family:
            DINPro,
            -apple-system,
            BlinkMacSystemFont,
            'Segoe UI',
            Roboto,
            Oxygen,
            Ubuntu,
            Cantarell,
            'Fira Sans',
            'Droid Sans',
            'Helvetica Neue',
            sans-serif;
          color: #949494;
          font-size: 15px;
          margin: 5px 0;
        }

        .download-link {
          cursor: pointer;
          text-align: center;
          display: inline-block;
          margin-top: 15px;
          color: #e4e4e4;
          background-color: #141414;
          text-decoration: none;
          font-family: 'Eurostile-Bold';
          font-weight: 400;
          font-size: 16px;
          line-height: 20px;
          border: 2px solid #e4e4e4;
          padding: 10px 20px;
          border-radius: 5px;
          transition:
            background-color 0.3s ease,
            color 0.3s ease;
        }

        .download-link:hover {
          background-color: #e4e4e4;
          color: #141414;
        }

        @media (max-width: 768px) {
          .driver-card {
            display: block;
            max-width: 90%;
          }
        }
      `}</style>
    </>
  );
};

export default DriversSlice;
